import React from 'react';

import styles from './userAccountShowPageStyles.scss';

import ChangeEmailContainer from '@buyside/components/container/UserAccount/ChangeEmailContainer';
import ChangePasswordContainer from '@buyside/components/container/UserAccount/ChangePasswordContainer';

import { useCurrentUserAccountShowPageQuery } from '@interfaces/graphql-typings';

import LoadingSpinner, {
  SIZES
} from '@buyside/components/presentation/LoadingSpinner/loadingSpinner';

const UserAccountShowPage = (): React.ReactElement => {
  const { loading, data } = useCurrentUserAccountShowPageQuery();

  if (loading || !data?.currentUser) return <LoadingSpinner size={SIZES.LARGE} />;

  return (
    <div>
      <h1 className={styles.pageTitle}>Email Address & Password</h1>
      <h2 className={styles.subsecTitle}>Email</h2>
      <ChangeEmailContainer currentUser={data.currentUser} />
      <h2 className={styles.subsecTitle}>Password</h2>
      <ChangePasswordContainer currentUser={data.currentUser} />
    </div>
  );
};

export default UserAccountShowPage;
